import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import SpeedIcon from "@mui/icons-material/Speed";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import ViewDayIcon from "@mui/icons-material/ViewDay";
import WorkIcon from "@mui/icons-material/Work";
import { Box, Container, Grid } from "@mui/material";
import CryptoFeeds from "../../../components/CryptoFeeds";
import CryptoOfferingCard from "../../../components/CryptoOfferingCard";
import CryptoOfferingCarousel from "../../../components/CryptoOfferingCarousel";
import CryptoOfferingData from "../../../components/CryptoOfferingData";
import PageHero from "../../../components/PageHero";
import { useAppDispatch, useAppSelector } from "../../../hooks/useStore";
import {
  selectCryptocurrencies,
  fetchCryptocurrencies,
} from "../../../redux/slices/assets";
import { getAnalyzerToken } from "../../../redux/slices/auth";
import {
  Root,
  main,
  MainHeading,
  mainText,
  sectionContainer,
  SectionBorder,
} from "./styles";

const CARDS = [
  {
    id: 0,
    icon: <ViewDayIcon />,
    title: "Range of Strategies",
    content: "Size, sector, thematic, quantitative, ESG...",
  },
  {
    id: 1,
    icon: <WorkIcon />,
    title: "Broad Coverage",
    content: "Universe of more than 1000 tokens.",
  },
  {
    id: 2,
    icon: <SearchIcon />,
    title: "Data Expertise",
    content: "Cleansed, normalized, reference and market data.",
  },
  {
    id: 3,
    icon: <SpeedIcon />,
    title: "EU Benchmark Regulation",
    content:
      "As a BMR administrator, our indexes are fully compliant with BMR and IOSCO.",
  },
  {
    id: 4,
    icon: <ThermostatIcon />,
    title: "Institutional-grade fixings",
    content: "Customizable fixing timings and methodologies.",
  },
];

const CryptoOffering = () => {
  const dispatch = useAppDispatch();

  const cryptocurrencies = useAppSelector(selectCryptocurrencies);

  useEffect(() => {
    dispatch(fetchCryptocurrencies());
  }, [dispatch]);

  useEffect(() => {
    // Get analyzer api token, which is required in future api requests
    dispatch(
      getAnalyzerToken({
        username: process.env.REACT_APP_ANALYZER_API_USER ?? "",
        password: process.env.REACT_APP_ANALYZER_API_PWD ?? "",
      })
    );
  }, [dispatch]);

  return (
    <Root>
      <PageHero
        colorScheme="gray"
        mainContentColorScheme="dark"
        title="Crypto Index and Data Offering"
        subTitle="Empower your cryptocurrency strategies."
      />

      <Container sx={{ ...main }}>
        <Box>
          <MainHeading>Pioneering on Crypto</MainHeading>
          <Box sx={{ ...mainText }} mt={3}>
            One of the world's first crypto indexers, BITA offers the world's
            widest coverage of crypto indexes and strategies. From traditional
            size indexes to sectorial and thematic strategies, we help global
            institutions to launch unique, innovative investment products.
          </Box>
        </Box>

        <Grid sx={{ ...sectionContainer }} container spacing={3}>
          {CARDS.map((card) => (
            <Grid key={card.id} item xs={12} sm={6}>
              <CryptoOfferingCard {...card} />
            </Grid>
          ))}
        </Grid>
        <Box sx={{ ...SectionBorder }} />
      </Container>

      <Box>
        <CryptoOfferingData />
        <Container>
          <Box sx={{ ...SectionBorder }} pt={0} />
        </Container>
      </Box>

      <Container sx={{ ...main }}>
        <MainHeading>BITA Crypto Data · Consolidated Feeds</MainHeading>

        <Box>
          <CryptoFeeds cryptocurrencies={cryptocurrencies} />
        </Box>
        <Box sx={{ ...SectionBorder }} />
      </Container>

      <Container sx={{ ...main }}>
        <Box>
          <MainHeading>BITA Cryptocurrency Indexes</MainHeading>
          <Box>
            <CryptoOfferingCarousel />
          </Box>
        </Box>
      </Container>
    </Root>
  );
};

export default CryptoOffering;
